import React, { useState, useEffect } from "react";
import { MonitorX } from "lucide-react";

// Halaman admin khusus desktop: di HP/tablet kecil tampil pesan
// "Your Device is not compatible to open this page".
export default function DesktopOnly({ children, minWidth = 1024 }) {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window === "undefined" ? true : window.innerWidth >= minWidth
  );

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${minWidth}px)`);
    const update = () => setIsDesktop(mq.matches);
    update();
    mq.addEventListener("change", update);
    window.addEventListener("resize", update);
    return () => {
      mq.removeEventListener("change", update);
      window.removeEventListener("resize", update);
    };
  }, [minWidth]);

  if (isDesktop) return <>{children}</>;

  return (
    <div className="min-h-screen grid place-items-center bg-[#f6f8fc] px-6" data-testid="desktop-only-block">
      <div className="card p-10 text-center max-w-sm">
        <MonitorX className="h-12 w-12 text-brand-300 mx-auto" />
        <p className="font-extrabold text-brand-800 text-lg mt-4">
          Your Device is not compatible to open this page
        </p>
        <p className="text-sm text-brand-400 mt-2">
          Halaman admin hanya bisa dibuka dari tablet besar atau komputer desktop.
        </p>
      </div>
    </div>
  );
}
